import type { FeatureBlockData } from '@af/design-system-docs-ui/feature-block';

// oxlint-disable import/extensions -- PNG imports require explicit extension for eslint's no-unresolved
import principleColorSignalDark from '../_assets/principle-color-signal-dark.png';
import principleColorSignalLight from '../_assets/principle-color-signal-light.png';
import principleEarnedExpressionDark from '../_assets/principle-earned-expression-dark.png';
import principleEarnedExpressionLight from '../_assets/principle-earned-expression-light.png';
import principleFamiliarityDark from '../_assets/principle-familiarity-dark.png';
import principleFamiliarityLight from '../_assets/principle-familiarity-light.png';
import principleIntegratedDark from '../_assets/principle-integrated-dark.png';
import principleIntegratedLight from '../_assets/principle-integrated-light.png';
import principleMotionDark from '../_assets/principle-motion-dark.png';
import principleMotionLight from '../_assets/principle-motion-light.png';
import principleSentientDark from '../_assets/principle-sentient-dark.png';
import principleSentientLight from '../_assets/principle-sentient-light.png';
// oxlint-enable import/extensions

export const principles: FeatureBlockData[] = [
	{
		title: 'Integrated, not segregated',
		description:
			'Rovo lives where work already happens, embedded alongside everything else rather than set apart.',
		image: { src: principleIntegratedLight, srcDark: principleIntegratedDark, alt: '' },
	},
	{
		title: 'Earned expression',
		description:
			'Rovo’s expression scales. It’s invisible until needed, present while working, fully expressive when AI is front and center.',
		image: { src: principleEarnedExpressionLight, srcDark: principleEarnedExpressionDark, alt: '' },
	},
	{
		title: 'Motion with intent',
		description:
			'Rovo is recognized through how it moves. Motion shows state and progress, guides attention, and helps users navigate.',
		image: { src: principleMotionLight, srcDark: principleMotionDark, alt: '' },
	},
	{
		title: 'Color as signal',
		description:
			'Rovo color is applied to specific signifiers, not whole surfaces. Restraint and intent make those moments land.',
		image: { src: principleColorSignalLight, srcDark: principleColorSignalDark, alt: '' },
	},
	{
		title: 'Sentient and responsive',
		description:
			'The dialect responds to user attention, context, and intent. It’s adaptive and aware but never just for show.',
		image: { src: principleSentientLight, srcDark: principleSentientDark, alt: '' },
	},
	{
		title: 'Familiar through consistency',
		description:
			'Rovo patterns are standardized, so makers can build with confidence and users always know what to expect.',
		image: { src: principleFamiliarityLight, srcDark: principleFamiliarityDark, alt: '' },
	},
];
